export default __webpack_public_path__ + "static/media/me3Removebg.b9cb3387.png";